// Banner verde «Promos de venta»: las de categoría o de toda la tienda, a qué aplican y qué dan.
// En «Elige el teléfono» las de teléfonos y kits; en Extras las que tocan accesorios. Sin promos no se pinta.
import { Tag } from 'lucide-react';
import { PromoBanner } from '@/domains/sales/wizard/components/PromoBanner';
import type { CatalogItem } from '@/domains/sales/wizard/types';
import { useStoreSalePromotions } from '../api/useWizardPromotions';
import { extrasBannerLowersPrice, extrasBannerRows } from '../lib/extrasBenefits';
import { forAnchor } from '../lib/promotionAppliesTo';
import { saleBannerRows } from '../lib/saleBenefits';

export type SaleBannerScreen = 'phones' | 'extras';

export function SalePromotionsBanner({
    sessionId,
    items,
    screen = 'phones',
    anchorWithoutSureKeep = false,
}: {
    sessionId: string;
    /** Productos de la pantalla, para decir a cuántos alcanza cada promo. */
    items: readonly CatalogItem[];
    screen?: SaleBannerScreen;
    /** Extras de un equipo que SureKeep no financia: sin las promos solo SureKeep. */
    anchorWithoutSureKeep?: boolean;
}) {
    const { data } = useStoreSalePromotions(sessionId);
    const promotions = forAnchor(data?.items ?? [], anchorWithoutSureKeep);
    const extras = screen === 'extras';
    const rows = extras ? extrasBannerRows(promotions, items) : saleBannerRows(promotions, items);
    if (rows.length === 0) return null;

    const summary = !extras
        ? 'Descuentos, bonos y regalos'
        : extrasBannerLowersPrice(promotions)
          ? 'Bajan el precio de los accesorios'
          : 'Dan beneficios con los extras';
    return (
        <PromoBanner
            tone="sale"
            label="Promos de venta"
            icon={Tag}
            summary={summary}
            columns={['Promo', 'Aplica a', 'Da']}
            rows={rows}
        />
    );
}
